<template>
  <div class="tab-history">
    <vpreloader v-if="isLoadingResponseHistory" />

    <div v-if="groupedResponseHistory.length > 0" class="tab-history__list">
      <div v-for="item in groupedResponseHistory" :key="item.created_at + Math.random()">
        <vcv-tab-history-item
          :item="item"
          :is-opened="currentMenu === item.created_at"
          @toggle-children-menu="toggleChildrenMenu"
        />

        <template v-if="item.children !== undefined && currentMenu === item.created_at">
          <vcv-tab-history-item v-for="child in item.children" :key="child.created_at + Math.random()" :item="child" />
        </template>
      </div>
    </div>

    <div v-if="!isLoadingResponseHistory && responseHistory.length === 0" class="tab-history__list">
      {{ $tr('common.table-no-data') }}
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import VcvTabHistoryItem from '@/components/response/tabs/VcvTabHistoryItem.vue';

export default {
  name: 'VcvTabHistory',

  components: {
    VcvTabHistoryItem
  },

  data() {
    return {
      currentMenu: null // open menu by created_at flag. Отстой, но тут что с бэка пришло и как-то надо было группировать.
    };
  },

  computed: {
    ...mapState('response', ['responseHistory', 'isLoadingResponseHistory']),

    groupedResponseHistory() {
      let newHistory = [];
      let isNextFraud = false;

      this.responseHistory.forEach(x => {
        if (x.type === 6) {
          if (isNextFraud) {
            if (newHistory[newHistory.length - 1].children !== undefined) {
              newHistory[newHistory.length - 1].children.push(x);
            } else {
              newHistory[newHistory.length - 1].children = [x];
            }
          } else {
            newHistory.push({ type: x.type, created_at: x.created_at, children: [x], isMenuOpen: false });
            isNextFraud = true;
          }
        } else {
          newHistory.push(x);
          isNextFraud = false;
        }
      });

      return newHistory;
    }
  },

  async created() {
    await this.fetchResponseHistory(true);
  },

  beforeDestroy() {
    // clear response history for memory clear
    this.SET_RESPONSE_HISTORY([]);
  },

  methods: {
    ...mapMutations('response', ['SET_RESPONSE_HISTORY']),

    ...mapActions('response', ['fetchResponseHistory']),

    toggleChildrenMenu(item) {
      if (item.type !== 6) return;

      if (this.currentMenu === null) {
        this.currentMenu = item.created_at;
      } else {
        this.currentMenu = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tab-history {
  &__list {
    color: $main-dark;
    display: flex;
    flex-direction: column;
  }
}
</style>
